import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCampaignPbxConfigService} from '../../services/vna-campaign-pbx-config.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

import * as _ from 'underscore';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPbxConfigCreated} from '../../model/VnaPbxConfigCreated';

@Component({
  selector: 'app-vna-campaign-pbx-config-edit',
  templateUrl: './vna-campaign-pbx-config-edit.component.html',
  styleUrls: ['./vna-campaign-pbx-config-edit.component.scss']
})
export class VnaCampaignPbxConfigEditComponent extends ModalExtended implements OnInit {

    formData: FormGroup;
    data: Object;
    loading: boolean = false;
    submitted: boolean = false;

    errors: Object = {};

    filesToUpload: Array<File> = [];
    currentFiles: Array<string> = [];

    constructor(private fb: FormBuilder, private campPbx: VnaCampaignPbxConfigService, private alertService: AlertaService, private messaging: MessagingService) {
        super();
        this.formData = this.fb.group({
            'service_campaign_action_pk': new FormControl(''),
            'phone_caller_id_pk': new FormControl('', Validators.required),
            'cc_caller_id' : new FormControl(''),
            'use_amd' : new FormControl('0'),
            'amd_config' : new FormControl('3000,3000,800,4000,100,50,5,256'),
            'provider': new FormControl('', Validators.required),
            'cc_provider': new FormControl(),
            'active': new FormControl('0'),
            'type' : new FormControl('', Validators.required),
            'recording_call' : new FormControl('0')
        })
    }

    savePbxConfig(): void {

        this.errors = {};
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        const formData: FormData = this.createFormData();

        this.campPbx.postPbxConfig(this.data['camp'].pkCamp, formData).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors;
                }
                else{
                    this.alertService.addAlert('success', 'PABX config have been created successfully');
                    if(result['data'].hasOwnProperty('new_url_originate')){
                        this.messaging.sendMessage(new VnaPbxConfigCreated(result['data']['new_url_originate']));
                    }
                }

                this.loading = false;
            }
        )

    }

    updatePbxConfig(): void {

        this.errors = {};
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        const formData: FormData = this.createFormData();

        this.campPbx.putPbxConfig(this.data['camp'].pkCamp, this.data['element']['pk'], formData).subscribe(
            (result) => {
                (result.hasOwnProperty('errors'))
                    ? this.errors = result.errors
                    : this.alertService.addAlert('success', 'PABX config have been updated successfully')
                ;
                this.loading = false;
            }
        )
    }

    clonePbxConfig(): void {
        this.errors = {};
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        const formData: FormData = this.createFormData();
        formData.append('loc_files', JSON.stringify(this.currentFiles));

        this.campPbx.postPbxConfig(this.data['camp'].pkCamp, formData, true).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors;
                }
                else{
                    this.alertService.addAlert('success', 'PABX config have been cloned successfully');
                    if(result['data'].hasOwnProperty('new_url_originate')){
                        this.messaging.sendMessage(new VnaPbxConfigCreated(result['data']['new_url_originate']));
                    }
                }

                this.loading = false;
            }
        )
    }

    onExit(): void {
        this.applyCallback(true);
        this.close();
    }

    fileChangeEvent(fileInput: any) {
        this.filesToUpload.push(fileInput.target.files[0]);
    }

    removeFile(i: number): void {
        this.filesToUpload.splice(i, 1);
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('element')){
            this.formData.controls['service_campaign_action_pk'].setValue(this.data['element']['service_campaign_action_pk']);
            this.formData.controls['phone_caller_id_pk'].setValue(this.data['element']['phone_caller_id_pk']);
            this.formData.controls['cc_caller_id'].setValue(this.data['element']['cc_caller_id']);
            this.formData.controls['provider'].setValue(this.data['element']['provider']);
            this.formData.controls['cc_provider'].setValue(this.data['element']['cc_provider']);
            this.formData.controls['active'].setValue(this.data['element']['active']);
            this.formData.controls['use_amd'].setValue(this.data['element']['use_amd']);
            this.formData.controls['amd_config'].setValue(this.data['element']['amd_config']);
            this.formData.controls['type'].setValue(this.data['element']['type']);
            this.formData.controls['recording_call'].setValue(this.data['element']['recording_call']);

            if(!_.isEmpty(this.data['element']['loc_files'])){
                for(const key in this.data['element']['loc_files']){
                    this.currentFiles.push(this.data['element']['loc_files'][key]);
                };
            }
        }
    }

    protected createFormData(): FormData {

        const formData: any = new FormData();
        const files: Array<File> = this.filesToUpload;

        for(let i =0; i < files.length; i++){
            formData.append("files[]", files[i], files[i]['name']);
        }

        formData.append('phone_caller_id_pk', this.formData.value['phone_caller_id_pk']);
        formData.append('cc_caller_id', this.formData.value['cc_caller_id']);
        formData.append('provider', this.formData.value['provider']);
        formData.append('cc_provider', this.formData.value['cc_provider']);
        formData.append('service_campaign_action_pk', this.formData.value['service_campaign_action_pk']);
        formData.append('active', this.formData.value['active']);
        formData.append('use_amd', this.formData.value['use_amd']);
        formData.append('amd_config', this.formData.value['amd_config']);
        formData.append('type', this.formData.value['type']);
        formData.append('recording_call', this.formData.value['recording_call']);

        return formData;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/vna-campaign-pbx-config-edit/vna-campaign-pbx-config-edit.component.ts